import type { Root, Text, HTML } from "mdast";
import { visit } from "unist-util-visit";

export const remarkPointBoxToKebab = () => {
  function transformer(tree: Root) {
    visit(tree, (node, index, parent) => {
      if (!parent) return;
      if (node.type === "code" || node.type === "inlineCode") return;

      if (node.type === "text" || node.type === "html") {
        const original = (node as Text | HTML).value;
        const replaced = original.replace(
          /<\s*(\/?)\s*point_box(?=[\s>\/])/gi,
          (_, slash: string) => `<${slash}point-box`,
        );

        if (replaced !== original) {
          if (node.type === "text") {
            // Promote text → html so rehype-raw will actually parse it
            parent.children[index!] = { type: "html", value: replaced };
          } else {
            (node as HTML).value = replaced;
          }
        }
      }
    });
  }

  return transformer;
};
